import React from "react";
import {useState, useEffect} from "react";
import axios from "axios";
import api from "../api";
import {
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = theme => ({
    root: {
      flexGrow: 1,
      width: "100%"
    },
    appBar: {
      position: "relative"
    },
    title: {
      marginLeft: "2rem",
      flex: 1,
      color: "white"
    },
    paper: {
      padding: "2rem",
      textAlign: "center"
    },
    checkedIcon: {
      width: 16,
      height: 16
    },
    option: {
      fontWeight: 600,
      fontSize: "0.75rem"
    },
    typography: {
      fontSize: "0.75rem"
    },
    select: {
      marginTop: "8px",
      marginRight: "8px"
    },
    tableCell: {
      padding: "8px 4px 8px 4px",
      border: "1px solid #dee2e6"
    }
  });
  
  
const WorkOrderInvoices = ({work_order_id}) => {
    const [invoices, setInvoices] = useState([]);
    const [creditNotes, setCreditNotes] = useState([]);
    const [debitNotes, setDebitNotes] = useState([]);
    const [showInvoices, setShowInvoices] = useState(true);
    const [showCreditNotes, setShowCreditNotes] = useState(false);
    const [showDebitNotes, setShowDebitNotes] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        getInvoices();
    }, [work_order_id]);

    const token = localStorage.getItem("userToken");
    const getInvoices = async () => {
        try {
            const response = await axios.get(api.work_order().invoices(work_order_id), {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setInvoices(response.data.invoices);
            setCreditNotes(response.data.credit_notes);
            setDebitNotes(response.data.debit_notes);
            setLoading(false);
        } catch (error) {
            setError(error);
            setLoading(false);
        }
    }

    const handleViewInvoice = (invoice_id) => {
        window.open(`/invoice/${invoice_id}`, "_blank");
    }
    const handleViewCreditNote = (creditNote_id, invoice_id) => {
        window.open(`/credit-note/${creditNote_id}/${invoice_id}`, "_blank");
    }
    const handleViewDebitNote = (debitNote_id, invoice_id) => {
        window.open(`/debit-note/${debitNote_id}/${invoice_id}`, "_blank");
    }

    const classes = useStyles();

    if (loading) {
        return <CircularProgress />;
    }
    return (
      <div className="row">
        <div className="col-md-12">
          <Typography variant="body1" className="my-2">Facturas Venta</Typography>
          <Table
            size="small"
            aria-label="a dense table"
            style={{ width: "auto", minWidth: "650px" }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                > 
                    Número de factura
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                    Fecha de factura
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                    Total de la factura
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                    Acciones
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invoices.map((invoice) => (
                <TableRow key={invoice.id}>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {invoice.number}
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {invoice.invoice_date}
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontSize: "0.75rem" }}
                  >
                    ${invoice.total}
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontSize: "0.75rem" }}
                  >
                    <Button variant="outlined" color="primary" onClick={() => handleViewInvoice(invoice.id)} style={{fontSize: "0.75rem"}}>
                        Ver factura
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
        {
          creditNotes.length > 0 && (
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-12 d-flex align-items-center my-2"
                onClick={() => setShowCreditNotes(prev => !prev)}
              >
              <Typography variant="body1" className="mb-0 mr-1">
                Notas de Crédito
              </Typography>
              <IconButton
                size="small"
                onClick={() => setShowCreditNotes(prev => !prev)}
                aria-label={
                  showCreditNotes
                    ? "Ocultar notas de crédito"
                    : "Ver notas de crédito"
                }
              >
                {showCreditNotes ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </div>
          </div>
          {
            showCreditNotes && (
              <Table
            size="small"
            aria-label="a dense table"
            style={{ width: "auto", minWidth: "650px" }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                > 
                    Número de nota de crédito
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                    Fecha de nota de crédito
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ fontWeight: "550" }}
                >
                    Acciones
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {creditNotes.map((creditNote) => (
                <TableRow key={creditNote.id}>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {creditNote.number}
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {creditNote.date}
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontSize: "0.75rem" }}
                  >
                    <Button variant="outlined" color="primary" onClick={() => handleViewCreditNote(creditNote.id, creditNote.invoice_id)} style={{fontSize: "0.75rem"}}>
                        Ver nota de crédito
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          )}
          </div>        
        )}
        {
          debitNotes.length > 0 && (
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-12 d-flex align-items-center my-2"
                onClick={() => setShowDebitNotes(prev => !prev)}
              >
              <Typography variant="body1" className="mb-0 mr-1">
                Notas de Débito
              </Typography>
              <IconButton
                size="small"
                onClick={() => setShowDebitNotes(prev => !prev)}
                aria-label={
                  showDebitNotes
                    ? "Ocultar notas de débito"
                    : "Ver notas de débito"
                }
              >
                {showDebitNotes ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </div>
          </div>
          {
            showDebitNotes && (
          <Table
              size="small"
              aria-label="a dense table"
              style={{ width: "auto", minWidth: "650px" }}
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: "550" }}
                  > 
                      Número
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: "550" }}
                  >
                      Fecha
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: "550" }}
                  >
                      Acciones
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {debitNotes.map((debitNote) => (
                  <TableRow key={debitNote.id}>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontSize: "0.75rem" }}
                    >
                      {debitNote.number}
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontSize: "0.75rem" }}
                    >
                      {debitNote.date}
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontSize: "0.75rem" }}
                    >
                      <Button variant="outlined" color="primary" onClick={() => handleViewDebitNote(debitNote.id, debitNote.invoice_id)} style={{fontSize: "0.75rem"}}>
                          Ver nota de débito
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          )}
          </div>        
        )}
      </div>

    )
}

export default WorkOrderInvoices;